import { render } from "./AuthenticationCardLogo.vue?vue&type=template&id=9b587c04"
import script from "./AuthenticationCardLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthenticationCardLogo.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/AuthenticationCardLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b587c04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b587c04', __exports__)) {
    api.reload('9b587c04', __exports__)
  }
  
  module.hot.accept("./AuthenticationCardLogo.vue?vue&type=template&id=9b587c04", () => {
    api.rerender('9b587c04', render)
  })

}


export default __exports__